import {useCallback, useState} from "react";
import clsMerge from "./clsMerge";

/**
 * A hook which simulates a loading state for a component.
 *
 * @param delayMs - The delay in milliseconds before the loading state is removed
 * @returns An object containing the loading state, a function to trigger the loading state, and a class name to apply to the component
 */
const useFakeLoading = (delayMs = 300) => {
	const [isLoading, setIsLoading] = useState(false);
	const triggerLoading = useCallback(() => {
		setIsLoading(true);
		setTimeout(() => {
			setIsLoading(false);
		}, delayMs);
	}, [delayMs]);
	const opacityLoadingClassName = clsMerge(
		"transition-opacity opacity-100",
		isLoading && "opacity-60 pointer-events-none"
	);
	return {isLoading, triggerLoading, opacityLoadingClassName};
};

export default useFakeLoading;
